import { z } from "zod";

export const stream = z.object({
  user: z.any().optional(),
  isLive: z.boolean().default(false).optional(),
  date: z.date().optional(),
  endDate: z.date().optional(),
  title: z.string().optional(),
  stream: z.string().optional(),
});
